const DiskInfo = ({ info, toggleinfostatus }) => {
  const closeIcon = (
    <svg
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M34.6923 1.06498L19.0001 16.7572L3.30786 1.06498C3.16065 0.917605 2.98583 0.800691 2.79341 0.720923C2.60098 0.641156 2.39472 0.600098 2.18642 0.600098C1.97812 0.600098 1.77186 0.641156 1.57943 0.720923C1.38701 0.800691 1.21219 0.917605 1.06498 1.06498C0.917605 1.21219 0.800691 1.38701 0.720923 1.57943C0.641156 1.77186 0.600098 1.97812 0.600098 2.18642C0.600098 2.39472 0.641156 2.60098 0.720923 2.79341C0.800691 2.98583 0.917605 3.16065 1.06498 3.30786L16.7572 19.0001L1.06498 34.6923C0.917605 34.8396 0.800691 35.0144 0.720923 35.2068C0.641156 35.3992 0.600098 35.6055 0.600098 35.8138C0.600098 36.0221 0.641156 36.2283 0.720923 36.4208C0.800691 36.6132 0.917605 36.788 1.06498 36.9352C1.21219 37.0826 1.38701 37.1995 1.57943 37.2793C1.77186 37.359 1.97812 37.4001 2.18642 37.4001C2.39472 37.4001 2.60098 37.359 2.79341 37.2793C2.98583 37.1995 3.16065 37.0826 3.30786 36.9352L19.0001 21.243L34.6923 36.9352C34.8396 37.0826 35.0144 37.1995 35.2068 37.2793C35.3992 37.359 35.6055 37.4001 35.8138 37.4001C36.0221 37.4001 36.2283 37.359 36.4208 37.2793C36.6132 37.1995 36.788 37.0826 36.9352 36.9352C37.0826 36.788 37.1995 36.6132 37.2793 36.4208C37.359 36.2283 37.4001 36.0221 37.4001 35.8138C37.4001 35.6055 37.359 35.3992 37.2793 35.2068C37.1995 35.0144 37.0826 34.8396 36.9352 34.6923L21.243 19.0001L36.9352 3.30786C37.0826 3.16065 37.1995 2.98583 37.2793 2.79341C37.359 2.60098 37.4001 2.39472 37.4001 2.18642C37.4001 1.97812 37.359 1.77186 37.2793 1.57943C37.1995 1.38701 37.0826 1.21219 36.9352 1.06498C36.788 0.917605 36.6132 0.800691 36.4208 0.720923C36.2283 0.641156 36.0221 0.600098 35.8138 0.600098C35.6055 0.600098 35.3992 0.641156 35.2068 0.720923C35.0144 0.800691 34.8396 0.917605 34.6923 1.06498Z"
        fill="#CCDBF0"
      />
    </svg>
  );
  return (
    <>
      {info ? (
        <div className="flex flex-col z-50 absolute w-[840px] h-[471px] bottom-[142px] left-[230px] rounded-[8px] shadow-medium p-[41.6px] bg-grey-928">
          <div className="flex items-center">
            <button onClick={() => toggleinfostatus()}>{closeIcon}</button>
            <div className="text-xl font-scaniacondensed pl-[65.6px]">
              Disk Usage
            </div>
          </div>
          <div className="flex flex-col text-lg font-scaniacondensed pt-[40px] text-light-1 opacity-70">
            <span className="pb-[22px]">
              Remeber to check the avaliable disk space before starting a new
              recording session.
            </span>
            <span>
              To prevent data loss the system will automatically stop an active
              recording before the disk gets full.
            </span>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default DiskInfo;
